import { styled, Stack, Typography, Box, Button } from "@mui/material";

export const ContainerStack = styled(Stack)({
    margin: "16px -16px",
    padding: "16px 16px",
    backgroundImage:
        "linear-gradient(to right bottom, #0056b8, #007cd1, #009dd3, #00bac3, #1dd4ad)",
});

export const SectionTitle = styled(Typography)({
    fontSize: "1.25rem",
    fontWeight: 400,
    color: "var(--community-color-snow-white)",
    marginBottom: "16px",
});

export const ButtonContainer = styled(Box)({
    textAlign: "right",
});

export const ViewAllButton = styled(Button)({
    textAlign: "right",
    textTransform: "none",
    marginTop: "-0.5rem",
    fontSize: "1rem",
    lineHeight: 1.5,
    padding: 0,
    letterSpacing: "normal",
    color: "var(--community-color-snow-white)",
    gap: "0.5rem",
    "& svg": {
        width: "auto",
        height: "0.75rem",
        fill: "var(--community-color-snow-white)",
    },
});

export const ViewAllButtonText = styled("span")({
    fontWeight: 400,
    fontFamily:
        'system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol !important',
    color: "var(--community-color-snow-white)",
});
